<template>

    <div>
        <Navigation :baseUrl="shopBaseUrl" :specialgroup="selectedSpecialGroup" :section="section" :group="group" :subGroup="subGroup" ></Navigation>

        <div v-if="reference" class="row m-5" ref="productsListRef">
            <div class="col-12 mt-4 text-center">
                <h4 class="text-dark search-keyword-title">Résultats pour "{{ reference }}"</h4>
            </div>
            
        </div>
        

        <div class="row" ref="productsListRef">

            

           
                <!-- Filter -->
                <div :class="{ 'col-12 col-md-4 col-lg-3 col-xl-2 filter-full-screen': openFilter, 'col-md-12 col-lg-12': !openFilter }" 
                        class="p-4" v-if="itemFilterData" v-show="openFilter" >
                    <div class="row">
                        <!-- <div class="col-6 text-left">
                            Filtrer
                        </div> -->

                        <div class="col-9 col-md-12 text-left">
                            <img  alt="" width="20px" class="d-none d-md-inline" src="@/assets/icons/fi-rr-cross-small.svg" style="cursor: pointer; " @click="openFilter = !openFilter"  />  
                            <img  alt="" width="20px" class="d-md-none" src="@/assets/icons/arrow-left.svg" style="cursor: pointer; " @click="openFilter = !openFilter"  />  
                        </div>

                        <div class="col-3 d-md-none text-right">
                           
                            <b-button variant="light" style="width: 100%" size="sm" class="font-size-14 font-weight-bold" @click="openFilter = !openFilter" >
                                 Filtrer
                            </b-button>
                        </div>

                    </div>                   


                    <div class="mt-4" v-if="  !reference &&   itemFilterData && itemFilterData.groupLinks && itemFilterData.groupLinks.length" >
                        <div class="filter-element-title">
                            SOUS-FAMILLES
                        </div>
                        <div class="list-container">
                            <ul class="item-list">
                                <simplebar  style="max-height:16em;  overflow-x:hidden;" >
                                    <div v-for="(groupLink, index) in itemFilterData.groupLinks" :key="index" class="title-class text-uppercase">
                                        <a class="title-class-link" :href="shopBaseUrl + '/' + groupLink.link "> 
                                            {{ groupLink.name }}
                                        </a>
                                    </div>
                                </simplebar>
                            </ul>
                        </div>
                    </div>

                    <!-- <div class=" mt-4 pt-4">
                        <div class="filter-element-title">
                            COULEURS
                        </div>
                        <ColorComponent v-if="itemFilterData && itemFilterData.colors && itemFilterData.colors.length" :colorList="itemFilterData.colors" @color-selected="updateSelectedColor"></ColorComponent>
                    </div> -->
                    
                    

                    <div v-if="itemFilterData && itemFilterData.sizes && itemFilterData.sizes.length" class="mt-4 pt-4">
                        <div class="filter-element-title"> 
                            
                            TAILLES
                        </div>
                        <FilterSizeComponent  :propSelectedSize="selectedSize" :sizes="itemFilterData.sizes" @size-selected="updateSelectedSize" @select-init="updateSelectedSizeInit"></FilterSizeComponent>
                    </div>

                    

                    <div class="mt-4 pt-4">
                        <div class="filter-element-title">
                            PRIX
                        </div>
                       
                        <FilterSliderMinMax :min="0" :max="itemFilterMaxPrice" :currency="this.itemFilterData.currency"
                            :propMinValue="selectedPrice ? selectedPrice.min : 0" 
                            :propMaxValue="selectedPrice ? selectedPrice.max :   itemFilterMaxPrice" 
                            @price-selected="updateSelectedPrice"/>

                    </div>
                    <!-- <div class="text-center">{{ this.sliderValue }} TND</div> -->

                    <div v-if="itemFilterData && itemFilterData.styles && itemFilterData.styles.length" class="mt-4 pt-4">
                        <div class="filter-element-title">
                            STYLE 
                        </div>

                        <div class="list-container">
                            <ul class="item-list">
                                <!-- <simplebar  style="max-height:16em;  overflow-x:hidden;" > -->

                                    
                                    <FilterStyleComponent  :propSelectedStyle="selectedStyle" :styles="itemFilterData.styles" @style-selected="updateSelectedStyle" @select-init="updateSelectedStyleInit"></FilterStyleComponent>


                                    <!-- <div v-for="(style, index) in itemFilterData.styles" :key="index" class="title-class text-uppercase">
                                        <a :class="{'font-weight-bold text-dark': selectedStyle && style.id == selectedStyle.id}" class="title-class-link text-secondary" href="javascript:void(0);" @click="updateSelectedStyle(style)">
                                            {{ style.name }}
                                        </a>
                                    </div> -->
                                <!-- </simplebar> -->
                            </ul>
                        </div>

                    </div>


                </div>

                <!-- Filter buttons and products -->
                <div  :class="{ 'col-12 col-md-8 col-lg-9 col-xl-10': openFilter, 'col-md-12 col-lg-12': !openFilter }">

                    <!-- Filter buttons -->
                    <div class="buttonRow pt-4">
                        <div class="filter" :class="openFilter ? 'filter-when-open' : ''" style="cursor: pointer;" >
                            

                            <div v-if="itemFilterData" @click="openFilter = !openFilter" class="getStarted d-none d-md-inline">
                                Filter  <img class="iconsettings" alt="" src="@/assets/images/Settings.png" /> 
                            </div>

                            <div v-if="itemFilterData" @click="openFilter = !openFilter" class="getStarted d-md-none">
                                Filter  <img class="iconsettings" alt="" src="@/assets/images/Settings.png" /> 
                            </div>

                            <!-- optinal item Section  -->
                            <div v-if="!reference" class="row ml-4 mt-2 mt-sm-2 mt-lg-0">
                                <div class="mt-2 mt-sm-0" v-show="optionalItemSections && optionalItemSections.length"  v-for="data in optionalItemSections" :key="data.id">
                                    <span :style="selectedOptionalItemSection && selectedOptionalItemSection.id === data.id ? 'background:#121212; color:#fff' : ''" 
                                        class="optionalItemSizeTitle optionalItemBox ml-2 mr-2" @click="setSelectedOptionalItemSection(data)">
                                    {{ data.name }}
                                    </span>
                                </div>
                            </div>
                           
                               
                            


                            <div class="ml-4 mt-2 mt-sm-2 mt-md-2 mt-lg-0">
                                <FilterBadge class="mt-2 mt-sm-0" v-if="selectedSize && selectedSize.name" @click="removeFilterSize()" :value="selectedSize.name" title="Taille"  />
                                <FilterBadge class="mt-2 mt-sm-0" v-if="selectedStyle && selectedStyle.name" @click="removeFilterStyle()" title="" :value="selectedStyle.name" />
                                <FilterBadge class="mt-2 mt-sm-0" v-if="selectedPrice" @click="removeFilterPrice()" title="" :value="selectedPrice.min + ' '+ itemFilterData.currency +'- ' + selectedPrice.max + ' '+ itemFilterData.currency " />

                            </div>

                        </div>
                        
                        <!-- <div class="sort">
                            <div class="sortText">Sort</div>
                            <img class="iconSort" alt="" src="@/assets/images/chevron-down.png" />
                        </div> -->

                    </div>

                    <!-- Products Grid -->
                    <div> 
                        <div v-if="itemsList && itemsList.length" class="row" style="padding-left: 1%; padding-right: 1%;">
                            <div :class="openFilter ? 'col-12 col-xl-4 col-lg-6 col-md-11  p-0 pt-4 pb-4 p-sm-2 p-lg-2 pt-lg-4 pb-lg-4 p-xxl-4' : 'col-12 col-xxl-3 col-xl-4 col-lg-4 col-md-6 p-0 pt-4 pb-4 p-sm-3 p-lg-2 pt-lg-4 pb-lg-4 p-xxl-4'"
                                v-for="(product, index) in itemsList" :key="index">
                                <ProductCard :product="product" />

                            </div>
                        </div>
                    </div>

                    <!-- Spinners and pagination -->
                    <div class="text-center" v-if="showItemsSpinner" >
                        <b-spinner variant="primary" ></b-spinner>
                    </div>

                    <div v-if="!this.showItemsSpinner && this.pagemodel.maxPagesCount != this.pagemodel.currentPage && this.pagemodel.totalRows != 0" class="paginationContainer mt-2 pt-4">
                        <div class="paginationButton" @click="loadMoreItems()">
                            <div class="paginationText">Afficher plus</div>
                        </div>
                    </div>

                    <div v-if="!this.showItemsSpinner && this.pagemodel.totalRows == 0" class="paginationContainer mt-2 pt-4" style="min-height:150px;">
                        <span class="text-warning">Aucun produit ne correspond à votre sélection</span>
                    </div>

                </div>
  

        </div>


    </div>
</template>
<script>
import ProductCard from "@/components/productCard.vue"
//import ColorComponent from "@/components/ColorComponent.vue"
import FilterSizeComponent from "@/components/FilterSizeComponent.vue"
import FilterStyleComponent from "@/components/FilterStyleComponent.vue"
import FilterBadge from "@/components/FilterBadge.vue"
import FilterSliderMinMax from "@/components/FilterSliderMinMax.vue"
import Navigation from "@/components/navigation.vue"
import ItemsApi from "@/services/items-api";
import simplebar from "simplebar-vue";

export default ({
    name: "shop",

    components: {
    ProductCard, FilterSizeComponent, FilterStyleComponent, Navigation, simplebar, FilterBadge, FilterSliderMinMax
},

    props: {
        product: Object,
    },

    data() {
        return {
            
            openFilter: false,
            selectedSize: null,
            selectedPrice: null,
            selectedStyle: null,
            currency: null,
            //selectedColor: null,


    //Items list
      itemsList:[],
      showItemsSpinner:false,
      itemsListTimestamp: null, 
      pagemodel: {currentPage : 1, perPage : 12, totalRows: 0, maxPagesCount: 0},
      
      section: null,
      group: null,
      subGroup: null,

      reference: null,
        
      //Filters
      selectedSectionName: null,
      selectedGroupName: null,
      selectedSubGroupName: null,
      selectedSpecialGroup: null,

      optionalItemSections: null,
      selectedOptionalItemSection: null,
     

      itemFilterData: null,
      catalogBanner:null,

        }
    },

    methods: {

        setSelectedOptionalItemSection(optionalItemSection){

            if (!optionalItemSection) {
                return;
            }

            if (this.selectedOptionalItemSection && this.selectedOptionalItemSection.id === optionalItemSection.id ) {
                this.selectedOptionalItemSection = null;
            } else {
                this.selectedOptionalItemSection = optionalItemSection ;
            }

            this.updateQueryUrl('subsection', this.selectedOptionalItemSection ? this.selectedOptionalItemSection.id : null);

            if (this.selectedSize) {
                this.removeFilterSize()
            }
            

            this.itemsList = [];
            this.pagemodel.currentPage=1;
            this.findItems();
        },

        getOptionalItemSection() {

            if (!this.selectedSectionName) {
                return;
            }

            ItemsApi.getOptionalItemSection(this.selectedSectionName).then(
                (optinalItemSections)=>{
                    if(optinalItemSections){
                        this.optionalItemSections = optinalItemSections
                    }
                });
        },

        removeFilterSize() {
            this.updateSelectedSizeInit(null);
            window.location.reload();
        },

        removeFilterPrice() {
            this.selectedPrice = null;
            this.updateQueryUrl('pricemin', this.selectedPrice ? this.selectedPrice.min : null);
            this.updateQueryUrl('pricemax', this.selectedPrice ? this.selectedPrice.max : null);
            window.location.reload();
        },

        removeFilterStyle() {
            this.updateSelectedStyleInit(null);
            window.location.reload();
        },
        
        updateSelectedColor(color) {
            this.selectedColor = color;
        },

        updateSelectedSizeInit(size) {
            this.selectedSize = size;
            this.updateQueryUrl('size', this.selectedSize ? this.selectedSize.id : null);
        },

        updateSelectedSize(size) {
            this.selectedSize = size;
            this.updateQueryUrl('size', this.selectedSize ? this.selectedSize.id : null);

            this.itemsList = [];
            this.pagemodel.currentPage=1;
            this.findItems();
        },

        updateSelectedPrice(price) {
            this.selectedPrice = price;
            this.updateQueryUrl('pricemin', this.selectedPrice ? this.selectedPrice.min : null);
            this.updateQueryUrl('pricemax', this.selectedPrice ? this.selectedPrice.max : null);

            this.itemsList = [];
            this.pagemodel.currentPage=1;
            this.findItems();
        },

        updateSelectedStyle(style) {
            this.selectedStyle = style;
            this.updateQueryUrl('style', this.selectedStyle ? this.selectedStyle.id : null);

            this.itemsList = [];
            this.pagemodel.currentPage=1;
            this.findItems();
        },

        updateSelectedStyleInit(style) {
            this.selectedStyle = style;
            this.updateQueryUrl('style', this.selectedStyle ? this.selectedStyle.id : null);
        },

        updateQueryUrl(key, value) {
            const currentUrl = new URL(window.location.href);

            if (value == null) {
                currentUrl.searchParams.delete(key);
            } else {
                currentUrl.searchParams.set(key, value);
            }

            window.history.pushState({}, '', currentUrl);
        },

        loadMoreItems() {
            this.pagemodel.currentPage++;
            this.findItems();
        },


        loadFilter() {

            ItemsApi.loadFilter( this.reference, 
                this.selectedSectionName,
                this.selectedGroupName,
                this.selectedSubGroupName,
                this.selectedSpecialGroup,
                this.selectedOptionalItemSection == null ? null : this.selectedOptionalItemSection.id    
            )
                
                .then(itemFilterData => {
                    if(itemFilterData){
                    
                        this.itemFilterData = itemFilterData;
                    
                    }

                       
            })
            .finally(() => {
              this.showItemsSpinner = false;
              //this.goTopPage();
            })
        },

    findItems() {

      this.showItemsSpinner = true;
      this.itemsListTimestamp = new Date().getTime();
        ItemsApi.findItems(
            this.pagemodel.currentPage, 
            this.pagemodel.perPage, 

            this.reference, 

            this.selectedSectionName,
            this.selectedGroupName,
            this.selectedSubGroupName,
            this.selectedSpecialGroup,

            this.selectedSize,
    
            this.selectedPrice == null ? null : this.selectedPrice.min,
            this.selectedPrice == null ? null : this.selectedPrice.max,

            this.selectedStyle,

            this.itemsListTimestamp , 
            this.selectedOptionalItemSection == null ? null : this.selectedOptionalItemSection.id    

        )

        .then(itemsList => {
              if(itemsList){

                if (itemsList.requestTimestamp && itemsList.requestTimestamp != this.itemsListTimestamp) {
                  return;
                }

                this.section = itemsList.section;
                this.group = itemsList.group;
                this.subGroup = itemsList.subGroup;

                this.itemsList.push(...itemsList.list)

                this.pagemodel.totalRows = itemsList.total;
                this.pagemodel.currentPage = itemsList.page;
                this.pagemodel.perPage = itemsList.pageSize;
                this.pagemodel.pageSize = itemsList.pageSize;
                this.pagemodel.maxPagesCount = itemsList.maxPagesCount;




                this.loadFilter();
                this.getOptionalItemSection();


               /* if (this.section && !this.group && !this.subGroup) {
                    document.title = 'HA | Collection ' + this.section.name;
                }

                if (this.section && this.group && !this.subGroup) {
                    document.title = 'HA | ' + this.group.name + " " + this.section.name;
                }

                if (this.section && this.group && this.subGroup) {
                    document.title = 'HA | ' + this.subGroup.name + " " + this.section.name;
                }*/


                
                        
              } else {

                this.itemsList = []
                this.pagemodel.totalRows = 0;
                this.pagemodel.currentPage = 1;
                this.pagemodel.maxPagesCount = 0;
              }
            })
            .finally(() => {
              this.showItemsSpinner = false;
              //this.goTopPage();
            })
        },



        beforeEnter(el) {
      el.style.transform = 'translateX(-100%)';
    },
    enter(el, done) {
      el.offsetHeight;
      el.style.transition = 'transform 0.5s';
      el.style.transform = 'translateX(0)';
      done();
    },
    leave(el, done) {
      el.offsetHeight;
      el.style.transition = 'transform 0.5s';
      el.style.transform = 'translateX(-100%)';
      done();
    },

    goTopPage() {
        //window.scrollTo({top: 0,left: 0,behavior: 'smooth'});

        this.$refs.productsListRef.scrollIntoView({ behavior: 'smooth', block: 'start' });

      },

      getCatalogBannerBySectionSeoName(itemSectionSeoName){

        ItemsApi.getCatalogBannerBySectionSeoName(itemSectionSeoName).then(
            (catalogBanner)=>{
                if(catalogBanner){
                    this.catalogBanner = catalogBanner
                    this.$emit('catalogBannerImage', this.catalogBanner);

                }
            }
        )
      }
   

    },

    watch :{

        group: function(){
            this.$emit('bannerTitle', this.group && this.group.name ?  this.group.name : this.section && this.section.name ? this.section.name : null );
        },
        section: function(){
            this.$emit('bannerTitle', this.group && this.group.name ?  this.group.name : this.section && this.section.name ? this.section.name : null  );
           if(this.section){
            this.getCatalogBannerBySectionSeoName(this.section.seoName)
           }


        },

        '$route': {
            immediate: true,
            deep: true, 
            handler(route) {

                this.selectedSectionName  = route.params.section;
                this.selectedGroupName    = route.params.group;
                this.selectedSubGroupName = route.params.subgroup;
                this.selectedSpecialGroup = route.params.specialgroup;

                if (route.query.subsection) {
                    this.selectedOptionalItemSection =  {id: Number(route.query.subsection)};
                } else {
                    this.selectedOptionalItemSection = null;
                }

                if (route.query.size) {
                    this.selectedSize = {id: Number(route.query.size)};
                } else {
                    this.selectedSize = null;
                }

                if (route.query.pricemin ||  route.query.pricemax) {
                    this.selectedPrice = {min: Number(route.query.pricemin), max: Number(route.query.pricemax)};
                } else {
                    this.selectedPrice = null;
                }

                if (route.query.style) {
                    this.selectedStyle = {id: route.query.style};
                } else {
                    this.selectedStyle = null;
                }

                if (route.query.keyword) {
                    this.reference = route.query.keyword;

                    if (this.reference && this.reference.trim() !== "") {
                        this.itemsList = [];
                        this.pagemodel.currentPage=1;
                    }
                } else {
                    this.reference = null;
                }

                this.findItems();
            }
        },

        

    },

    computed: {

        itemFilterMaxPrice() {
            return this.itemFilterData && this.itemFilterData.maxPrice ? Math.ceil(this.itemFilterData.maxPrice) : 500;
        },

        shopBaseUrl() {
            return this.selectedSpecialGroup ? '/ha/' + this.selectedSpecialGroup : '/catalogue';
        }
    },
});
</script>
  
<style scoped>

.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s;
}
.slide-enter, .slide-leave-to /* .slide-leave-active in <2.1.8 */ {
  transform: translateX(0);
}
.slide-leave, .slide-enter-to /* .slide-enter-active in <2.1.8 */ {
  transform: translateX(-100%);
}

@media (min-width: 1450px) {
  .p-xxl-4 {
    padding: 1.5rem !important; /* Adjust padding value as needed */
  }
}

@media (min-width: 1450px) {
  .col-xxl-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }

  .col-xxl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.getStarted {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
}

.filter {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    text-align: left;
    font-size: 16px;
    color: #121212;
    font-family: Poppins;
    padding-left: 1.5%;
}

@media (max-width: 1000px) {
    .filter-when-open {
        display: inline;
    }
}

@media (max-width: 815px) {
    .filter {
        display: inline;
    }
}

.iconsettings {
    position: relative;
    width: 20px;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
}

.buttonRow {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 16px;
    color: #121212;
    font-family: Poppins;
    padding-left: 1%;
    padding-right: 1%;
}

.sortText {
    font-weight: 500;
}

.sort {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    text-align: left;
    font-size: 16px;
    color: #121212;
    font-family: Poppins;
    padding-right: 1.5%;
}

.iconSort {
    position: relative;
    width: 20px;
    height: 20px;
    overflow: hidden;
    flex-shrink: 0;
}

.paginationText {
    position: relative;
    line-height: 24px;
    font-weight: 500;
}

.paginationButton {
    border-radius: 6px;
    background-color: #fff;
    border: 1px solid #c0c0c0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 20px;
    cursor: pointer;
}

.paginationContainer {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    font-size: 14px;
    color: #000;
    font-family: Poppins;
}


.paginationText {
  position: relative;
  line-height: 24px;
  font-weight: 500;
}




.title-class {
    font-size: 14px;
    color: #807e7e;
    /*font-family: Inter;*/
    text-align: left;
    /*text-decoration: underline;*/
    margin-bottom: 10px;
    margin-left: 10%;
    cursor: pointer;
}



.title-class-link:hover {
    color: #121212;
    border-bottom: 2px solid #000;
}

/*.custom-slider {
    --track-color: #cbcbcb;
    --thumb-color: #121212;
    --track-height: 2px;
}*/

.dual-slider-container {
  position: relative;
}

.custom-slider {
  width: 100%;
  position: absolute;
  appearance: none;

  --track-color: #cbcbcb;
    --thumb-color: #121212;
    --track-height: 2px;
    top: 0;
}

.min-slider {
  z-index: 1;
  color: red;
}

.max-slider {
  z-index: 2;
}

input[type="range"].custom-slider {
    -webkit-appearance: none;
    appearance: none;
    width: 100%;
    height: var(--track-height);
    background-color: var(--track-color);
    outline: none;
}

input[type="range"].custom-slider::-moz-range-thumb {
    background-color: var(--thumb-color);
    width: 15px;
    height: 15px;
    border: none;
    border-radius: 50%;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
}

input[type="range"].custom-slider::-webkit-slider-thumb {
    background-color: var(--thumb-color);
    width: 15px;
    height: 15px;
    border: none;
    border-radius: 50%;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
    -webkit-appearance: none;
    margin-top: -7.5px;
}

input[type="range"].custom-slider::-ms-thumb {
    background-color: var(--thumb-color);
    width: 15px;
    height: 15px;
    border: none;
    border-radius: 50%;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
}

.filter-element-title {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.15em;
    color: #121212;
    display: inline-block;padding-bottom: 5%;
}

.list-container {
    padding: 10px;
    overflow-y: auto;
    /*max-height: 250px;*/
}

.item-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.style-class {
    position: relative;
    font-size: 14px;
    line-height: 22px;
    font-weight: 600;
    font-family: Inter;
    color: #807e7e;
    text-align: left;
    padding-bottom: 10%;
}

.style-class:hover {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    text-align: left;
    font-size: 14px;
    color: #121212;
    font-family: Inter;
    display: inline-block;
    border-bottom: 1px solid transparent;
    cursor: pointer;
}

.search-keyword-title {
    font-weight: bold;
    font-size: 44px;
    line-height: 44px;
    letter-spacing: 0.4px;
}

@media (max-width: 767px) {
    .filter-full-screen {
        position: fixed; 
        background: white;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999;
        overflow: auto;
    }
}

.optionalItemBox {
    border: 1px solid #cbcbcb;
    box-sizing: border-box;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 15px;
    cursor: pointer;
    transition: border-color 0.3s; 
    font-family: 'Space Grotesk' !important;
    font-weight: bold;
}
.optionalItemSizeTitle {
    line-height: 22px;
}

.optionalItemBox:hover {
    border-color: #121212;
}

</style>
  
  
  